import { FormikProps } from 'formik';
import {
  AudienceRetargetInput,
  ContentImproverInput,
} from '../../../../../types/FormTypes';
import { BoxedAutoResizeTextarea } from '../../../../shared/inputs/BoxedAutoResizeTextarea';

type OriginalCopyTextareaProps<T> = {
  formikProps: FormikProps<T>;
  disabled: boolean;
  title: string;
  subtitle: string;
  placeholder: string;
};

export function OriginalCopyTextarea<
  T extends ContentImproverInput | AudienceRetargetInput
>({
  formikProps,
  disabled,
  title,
  subtitle,
  placeholder,
}: OriginalCopyTextareaProps<T>) {
  return (
    <BoxedAutoResizeTextarea
      id="originalCopy"
      label={
        <div>
          <h2>{title}</h2>
          <p>{subtitle}</p>
        </div>
      }
      placeholder={placeholder}
      value={formikProps.values.originalCopy}
      setValue={formikProps.handleChange('originalCopy')}
      disabled={disabled}
      errors={formikProps.errors.originalCopy as string}
      touched={formikProps.touched.originalCopy ? true : false}
      onBlur={formikProps.handleBlur}
    />
  );
}
